import React from 'react';
import $ from 'jquery';
import { CONF_PUBLISHER } from '../../../../constants/Labels';
import { parseToFloat } from '../../../../helpers/tools';
class PublisherSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'publisher';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
    this.countdownTimeFormatList = {
      'mm:ss': 'mm:ss',
      ss: 'ss',
    };
  }

  componentDidMount() {
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }
  /** Used for import settings, to display on active tab errors */
  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('#' + this.section)
        .find('input[name="skipDelay"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="totalTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="numberOfPassbackAds"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'integer', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="bumperDuration"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'integer', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="integralAdScienceAnId"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'integer', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="requestTimeout"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="numMaxRedirect"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'integer', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="visibilityThresholdForPlayback"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="visibilityThresholdForUnmute"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', true, this);
          }).bind(this)
        );
    } else {
      $('#' + this.section)
        .find('input[name="skipDelay"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="totalTimeout"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="numberOfPassbackAds"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="bumperDuration"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="integralAdScienceAnId"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="requestTimeout"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="numMaxRedirect"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="visibilityThresholdForPlayback"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="visibilityThresholdForUnmute"]')
        .off('blur');
    }
  };

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle publisherTitle">Publisher Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_PUBLISHER }}
          ></div>
          <div className="inputsRow">
            <div className="smallInput">
              <div>
                <label>Force skip delay</label>
              </div>
              <p>
                <input
                  type="radio"
                  name="forceSkipDelay"
                  key={this.props.publisher.forceSkipDelay}
                  id="forceSkipDelay0"
                  defaultValue={true}
                  defaultChecked={this.props.publisher.forceSkipDelay === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="forceSkipDelay0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  name="forceSkipDelay"
                  key={!this.props.publisher.forceSkipDelay}
                  id="forceSkipDelay1"
                  defaultValue={false}
                  defaultChecked={this.props.publisher.forceSkipDelay === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="forceSkipDelay1">False</label>
              </p>
            </div>
            <div
              className="smallInput"
              style={{ display: this.props.publisher.forceSkipDelay === true ? 'block' : 'none' }}
              key={this.props.publisher.forceSkipDelay}
            >
              <label>Skip delay</label>
              <br />
              <input
                type="text"
                name="skipDelay"
                key={this.props.publisher.skipDelay}
                className="textFiled"
                defaultValue={this.props.publisher.skipDelay}
                min="-1"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Total timeout</label>
              <input
                type="text"
                name="totalTimeout"
                key={this.props.publisher.totalTimeout}
                className="textFiled"
                defaultValue={this.props.publisher.totalTimeout}
                min="0"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>Number of passback ads</label>
              <input
                type="number"
                name="numberOfPassbackAds"
                key={this.props.publisher.numberOfPassbackAds}
                className="textFiled"
                defaultValue={this.props.publisher.numberOfPassbackAds}
                min="-1"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Mute ads at startup</label>
              </div>
              <div className="smallInput">
                <label>Html5 seamless fullscreen</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  name="muteAdsAtStartup"
                  key={this.props.publisher.muteAdsAtStartup}
                  id="muteAdsAtStartup0"
                  defaultValue={true}
                  defaultChecked={this.props.publisher.muteAdsAtStartup === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="muteAdsAtStartup0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  name="muteAdsAtStartup"
                  key={!this.props.publisher.muteAdsAtStartup}
                  id="muteAdsAtStartup1"
                  defaultValue={false}
                  defaultChecked={this.props.publisher.muteAdsAtStartup === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="muteAdsAtStartup1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  name="html5SeamlessFullscreen"
                  key={this.props.publisher.html5SeamlessFullscreen}
                  id="html5SeamlessFullscreen0"
                  defaultValue={true}
                  defaultChecked={this.props.publisher.html5SeamlessFullscreen === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="html5SeamlessFullscreen0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  name="html5SeamlessFullscreen"
                  key={!this.props.publisher.html5SeamlessFullscreen}
                  id="html5SeamlessFullscreen1"
                  defaultValue={false}
                  defaultChecked={this.props.publisher.html5SeamlessFullscreen === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="html5SeamlessFullscreen1">False</label>
              </p>
            </div>
          </div>
          <div className="more">
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Allow conditional ad</label>
                </div>
                <div className="smallInput">
                  <label>Check universalAdId </label>
                </div>
              </div>
              <div className="smallInput">
                <p>
                  <input
                    type="radio"
                    name="allowConditionalAd"
                    key={this.props.publisher.allowConditionalAd}
                    id="allowConditionalAd0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.allowConditionalAd === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="allowConditionalAd0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="allowConditionalAd"
                    key={!this.props.publisher.allowConditionalAd}
                    id="allowConditionalAd1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.allowConditionalAd === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="allowConditionalAd1">False</label>
                </p>
              </div>
              <div className="smallInput">
                <p>
                  <input
                    type="radio"
                    name="checkUniversalAdId"
                    key={this.props.publisher.checkUniversalAdId}
                    id="checkUniversalAdId0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.checkUniversalAdId === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="checkUniversalAdId0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="checkUniversalAdId"
                    key={!this.props.publisher.checkUniversalAdId}
                    id="checkUniversalAdId1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.checkUniversalAdId === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="checkUniversalAdId1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Unmute on mouse over</label>
                </div>
                <div className="smallInput">
                  <label>Replay ad</label>
                </div>
              </div>
              <div className="smallInput">
                <p>
                  <input
                    type="radio"
                    name="unmuteOnMouseOver"
                    key={this.props.publisher.unmuteOnMouseOver}
                    id="unmuteOnMouseOver0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.unmuteOnMouseOver === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="unmuteOnMouseOver0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="unmuteOnMouseOver"
                    key={!this.props.publisher.unmuteOnMouseOver}
                    id="unmuteOnMouseOver1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.unmuteOnMouseOver === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="unmuteOnMouseOver1">False</label>
                </p>
              </div>
              <div className="smallInput">
                <p>
                  <input
                    type="radio"
                    name="replayAd"
                    key={this.props.publisher.replayAd}
                    id="replayAd0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.replayAd === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="replayAd0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="replayAd"
                    key={!this.props.publisher.replayAd}
                    id="replayAd1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.replayAd === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="replayAd1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <div>
                  <label>Pause ad when switching window / tab</label>
                </div>
                <p>
                  <input
                    type="radio"
                    name="enableAdPauseOnWindowChange"
                    key={this.props.publisher.enableAdPauseOnWindowChange}
                    id="enableAdPauseOnWindowChange0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.enableAdPauseOnWindowChange === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="enableAdPauseOnWindowChange0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="enableAdPauseOnWindowChange"
                    key={!this.props.publisher.enableAdPauseOnWindowChange}
                    id="enableAdPauseOnWindowChange1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.enableAdPauseOnWindowChange === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="enableAdPauseOnWindowChange1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <div>
                  <label>Load the HLS.js library</label>
                </div>
                <p>
                  <input
                    type="radio"
                    name="loadHlsJsLibrary"
                    key={this.props.publisher.loadHlsJsLibrary}
                    id="loadHlsJsLibrary0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.loadHlsJsLibrary === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="loadHlsJsLibrary0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="loadHlsJsLibrary"
                    key={!this.props.publisher.loadHlsJsLibrary}
                    id="loadHlsJsLibrary1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.loadHlsJsLibrary === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="loadHlsJsLibrary1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Bumper duration</label>
                <input
                  type="number"
                  name="bumperDuration"
                  key={this.props.publisher.bumperDuration}
                  className="textFiled"
                  defaultValue={this.props.publisher.bumperDuration}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Pre ad bumper image URL</label>
                <input
                  type="text"
                  name="bumperPreAdUrl"
                  key={this.props.publisher.bumperPreAdUrl}
                  className="textFiled"
                  defaultValue={this.props.publisher.bumperPreAdUrl}
                  onBlur={e => this.props.validate(e, 'string', false, this)}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Post ad bumper image URL</label>
                <input
                  type="text"
                  name="bumperPostAdUrl"
                  key={this.props.publisher.bumperPostAdUrl}
                  className="textFiled"
                  defaultValue={this.props.publisher.bumperPostAdUrl}
                  onBlur={e => this.props.validate(e, 'string', false, this)}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Countdown time format</label>
                </div>
                <div className="smallInput">
                  <label>Integral adScience an id</label>
                </div>
              </div>
              <div className="smallInput">
                <select
                  className="btnGeneral"
                  key={this.props.publisher.countdownTimeFormat}
                  name="countdownTimeFormat"
                  defaultValue={this.props.publisher.countdownTimeFormat}
                  onChange={e => this.props.handleOptionChange(e, this, String)}
                >
                  {Object.keys(this.countdownTimeFormatList).map(item => (
                    <option key={item} value={item}>
                      {this.countdownTimeFormatList[item]}
                    </option>
                  ))}
                </select>
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="integralAdScienceAnId"
                  key={this.props.publisher.integralAdScienceAnId}
                  className="textFiled"
                  defaultValue={this.props.publisher.integralAdScienceAnId}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <div>
                  <label>Enable mobile click through button</label>
                </div>
                <p>
                  <input
                    type="radio"
                    name="enableMobileClickThroughButton"
                    key={this.props.publisher.enableMobileClickThroughButton}
                    id="enableMobileClickThroughButton0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.enableMobileClickThroughButton === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="enableMobileClickThroughButton0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="enableMobileClickThroughButton"
                    key={!this.props.publisher.enableMobileClickThroughButton}
                    id="enableMobileClickThroughButton1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.enableMobileClickThroughButton === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="enableMobileClickThroughButton1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <div>
                  <label>Pause main content until VAST is loaded</label>
                </div>
                <p>
                  <input
                    type="radio"
                    name="pauseMainContentUntilVASTIsLoaded"
                    key={this.props.publisher.pauseMainContentUntilVASTIsLoaded}
                    id="pauseMainContentUntilVASTIsLoaded0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.pauseMainContentUntilVASTIsLoaded === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="pauseMainContentUntilVASTIsLoaded0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="pauseMainContentUntilVASTIsLoaded"
                    key={!this.props.publisher.pauseMainContentUntilVASTIsLoaded}
                    id="pauseMainContentUntilVASTIsLoaded1"
                    defaultValue={false}
                    defaultChecked={
                      this.props.publisher.pauseMainContentUntilVASTIsLoaded === false
                    }
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="pauseMainContentUntilVASTIsLoaded1">False</label>
                </p>
              </div>
            </div>
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Request timeout</label>
                </div>
                <div className="smallInput">
                  <label>Number of max redirect</label>
                </div>
              </div>
              <div className="smallInput">
                <input
                  type="text"
                  name="requestTimeout"
                  key={this.props.publisher.requestTimeout}
                  className="textFiled"
                  defaultValue={this.props.publisher.requestTimeout}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <input
                  type="number"
                  name="numMaxRedirect"
                  key={this.props.publisher.numMaxRedirect}
                  className="textFiled"
                  defaultValue={this.props.publisher.numMaxRedirect}
                  min="1"
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Visibility threshold for playback</label>
                <input
                  type="text"
                  name="visibilityThresholdForPlayback"
                  key={this.props.publisher.visibilityThresholdForPlayback}
                  className="textFiled"
                  defaultValue={this.props.publisher.visibilityThresholdForPlayback}
                  min="-1"
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>Visibility threshold for unmute</label>
                <input
                  type="text"
                  name="visibilityThresholdForUnmute"
                  key={this.props.publisher.visibilityThresholdForPlayback}
                  className="textFiled"
                  defaultValue={this.props.publisher.visibilityThresholdForUnmute}
                  min="-1"
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <label>SupplyChain Object</label>
                <input
                  type="text"
                  name="schain"
                  className="textFiled"
                  defaultValue={this.props.publisher.schain}
                  key={this.props.publisher.schain}
                  onBlur={e => this.props.validate(e, 'string', false, this)}
                />
                <div className="validationError"></div>
              </div>
            </div>
            <div className="inputsRow">
              <div className="bigInput">
                <div>
                  <label>Display vpaid creative first</label>
                </div>
                <p>
                  <input
                    type="radio"
                    name="vpaidFirst"
                    key={this.props.publisher.vpaidFirst}
                    id="vpaidFirst0"
                    defaultValue={true}
                    defaultChecked={this.props.publisher.vpaidFirst === true}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="vpaidFirst0">True</label>
                </p>
                <p>
                  <input
                    type="radio"
                    name="vpaidFirst"
                    key={!this.props.publisher.vpaidFirst}
                    id="vpaidFirst1"
                    defaultValue={false}
                    defaultChecked={this.props.publisher.vpaidFirst === false}
                    onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                  />
                  <label htmlFor="vpaidFirst1">False</label>
                </p>
              </div>
            </div>
          </div>
          <div className="moreButtonWrapper">
            <a className="moreButton" onClick={e => this.props.toggleElement(e, '.more')}>
              Show more options <span>▼</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PublisherSettings;
